module.exports = __webpack_public_path__ + "images/manifest/icon-96x96-44fece775401fd6184d71022778b4edd.png";